import React, { useRef, InputHTMLAttributes } from 'react';
import { FiSearch } from 'react-icons/fi';
import { maskCep, maskCpf } from '../Input/mask';

import { Container, ContainerLupa } from './styles';

interface SearchInterface extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  nomePlaceHolder: string;
  type?: string;
  inputColor?: string;
  onValue?: string;
  onSearch: (arg: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

const SearchIsolate = ({
  onSearch,
  onFocus,
  onBlur,
  maxLength,
  onValue,
  nomePlaceHolder,
  className,
  type,
  inputColor = '',
}: SearchInterface): any => {
  // const [search, setSearch] = useState('');
  const InputRef = useRef<HTMLInputElement>(null);

  const onInputChange = (value: string): void => {
    // setSearch(value);
    onSearch(value);
  };

  return (
    <Container>
      <ContainerLupa
        style={{ background: inputColor }}
        classNameProps={className || 'search1'}
        onClick={() => InputRef.current?.focus()}
      >
        <FiSearch color="#000000" size={22} />
      </ContainerLupa>
      <input
        ref={InputRef}
        style={{ background: inputColor }}
        className={className}
        type={type}
        placeholder={nomePlaceHolder}
        onFocus={onFocus}
        onBlur={onBlur}
        // defaultValue={onValue}
        value={onValue}
        maxLength={maxLength}
        onChange={(e) => {
          nomePlaceHolder === 'Buscar CPF'
            ? onInputChange((e.target.value = maskCpf(e.target.value)))
            : onInputChange(e.target.value);

          nomePlaceHolder === 'Buscar CEP'
            ? onInputChange((e.target.value = maskCep(e.target.value)))
            : onInputChange(e.target.value);
        }}
      />
    </Container>
  );
};

export default SearchIsolate;
